import type { StaffRow } from './buildStaffRows'

export type StaffStatusFilter = 'all' | 'active' | 'deactivated'

export const STAFF_STATUS_FILTERS: readonly {
  value: StaffStatusFilter
  label: string
}[] = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'deactivated', label: 'Deactivated' },
]

/** Whether a staff member in this state is one the chosen status shows. */
export const filterIncludesEnabled = (
  filter: StaffStatusFilter,
  isEnabled: boolean
): boolean => filter === 'all' || (filter === 'active') === isEnabled

/**
 * The staff to show for the chosen status.
 *
 * Filtered here rather than by the server: the list endpoint takes no status
 * parameter, and it returns the organization's whole staff in one response
 * anyway, so narrowing it in the browser costs nothing and switching between
 * the three choices needs no further request.
 *
 * Order is untouched — `buildStaffRows` has already decided it.
 */
export const filterStaffRows = (
  rows: StaffRow[],
  filter: StaffStatusFilter
): StaffRow[] =>
  rows.filter((row) => filterIncludesEnabled(filter, row.staff.enabled))
